import { MACROTRENDS, MICROTRENDS } from '@/model/workspace/trends'

export default {
    title: 'Looking for trends?',
    text: {
        [MICROTRENDS]: 'Use the trend finder to add micro-trends to your work space.',
        [MACROTRENDS]: 'Use the trend finder to add macro-trends to your work space.'
    },
    button: 'Find trends'
}
